import { useState } from "react"
import SVG from "../../../Components/SVG"

export default function PhaseContainer({header="", headSVG="", headSVGClassName="", children}) {

  return (
    <div className="w-full p-5 rounded-2xl flex flex-col gap-5 bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex gap-2.5 items-center">
        {headSVG && <SVG name={headSVG} classname={`size-5 stroke-zi-border-dark dark:stroke-zi-border-light ${headSVGClassName}`} /> }
        {header && <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">{header}</span>}
      </div>
      {children}
    </div>
  )
}